import type { Dimension, IndustryBenchmark, Research } from '@/api/types';

import { DimensionChart } from './DimensionChart';
import { recommendationOf } from './reportText';
import { Scorecard } from './Scorecard';
import { TextTile } from './TextTile';
import { Verdict } from './Verdict';

/** The summary strip: verdict and total, recommendation, rationale, summary, profile radar and the dimensions table. */
export function IdeaStrip({ research, dimensions, benchmark }: { research: Research; dimensions: Dimension[]; benchmark: IndustryBenchmark | null }) {
  return (
    <div className="metric-area idea-strip">
      <div className="idea-strip-grid">
        <Verdict research={research} />
        <TextTile label="Recommendation" text={recommendationOf(research)} className="idea-tile-recommendation" markdown />
        <TextTile label="Rationale" text={research.rationale} className="idea-tile-rationale" />
        <TextTile label="Summary" text={research.summary} className="idea-tile-summary" />
        <DimensionChart research={research} dimensions={dimensions} benchmark={benchmark} />
        <Scorecard research={research} dimensions={dimensions} />
      </div>
    </div>
  );
}
